export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Golf Tournament';
export const APP_BASE = import.meta.env.VITE_APP_BASE || '/';
export const TOURNAMENT_ID = import.meta.env.VITE_TOURNAMENT_ID as string;

export function withAppBase(path: string): string {
  const normalizedBase = APP_BASE === '/' ? '' : APP_BASE.replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}` || '/';
}
